const FormSubmit = ({label}) => {
    return (
        <button
            type="submit"
            className="btn btn-success"
        >
            {label}
        </button>
    )
}

export default FormSubmit;